import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: none;\n  border-radius: ", "px;\n  height: ", "px;\n  vertical-align: middle;\n  width: 100%;\n\n  &::-webkit-meter-bar {\n    background: ", ";\n    border: none;\n    border-radius: ", "px;\n    height: ", "px;\n  }\n\n  &::-moz-meter-bar {\n    border-radius: ", "px;\n  }\n\n  &::-webkit-meter-optimum-value {\n    border-radius: ", "px;\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &::-moz-meter-bar {\n      background: ", ";\n    }\n\n    &::-webkit-meter-optimum-value {\n      background: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
var BORDER_RADIUS = 3;
var METER_HEIGHT = 6;
var VALUE_BACKGROUND_BY_COLOR = {
  orange: css(_templateObject(), color.palette.yellow500, color.palette.yellow500)
};
var MeterBar = styled.meter(_templateObject2(), color.palette.grey800, BORDER_RADIUS, METER_HEIGHT, color.palette.grey800, BORDER_RADIUS, METER_HEIGHT, BORDER_RADIUS, BORDER_RADIUS, function (_ref) {
  var color = _ref.color;
  return VALUE_BACKGROUND_BY_COLOR[color];
});
export function Meter(_ref2) {
  var value = _ref2.value,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'orange' : _ref2$color;
  return React.createElement(MeterBar, {
    min: 0,
    value: value,
    max: 100,
    color: color
  }, value, "%");
}